import React from 'react';
import { List, Plus, BookOpen } from 'lucide-react';
import TabsContainer, { Tab } from '@/Components/TabsContainer/TabsContainer';
import CourseListTab from './CourseListTab';
import CreateCourseTab from './CreateCourseTab';
import CurriculumBuilderTab from './CurriculumBuilderTab';
import './CourseManagement.css';

const CourseManagement: React.FC = () => {
  const tabs: Tab[] = [
    {
      id: 'list',
      label: 'Course List',
      icon: List,
      content: <CourseListTab />,
      actionButton: (
        <button className="trainer-coursemanagement-create-btn">
          <Plus size={18} />
          Create New Course
        </button>
      ),
    },
    {
      id: 'create',
      label: 'Create Course',
      icon: Plus,
      content: <CreateCourseTab />,
    },
    {
      id: 'curriculum',
      label: 'Curriculum Builder',
      icon: BookOpen,
      content: <CurriculumBuilderTab />,
    },
  ];

  return (
    <div className="trainer-coursemanagement-container">
      <TabsContainer
        breadcrumb="Content Management › Course Management"
        title="Course Management"
        subtitle="Assemble content assets into structured courses and learning paths"
        tabs={tabs}
        defaultTab="list"
      />
    </div>
  );
};

export default CourseManagement;